import React, { useState } from "react";
import { FAQS } from "../mock/mock";
import { Plus, Minus } from "lucide-react";

export default function FAQ() {
  const [open, setOpen] = useState(0);
  return (
    <section className="py-24 md:py-32">
      <div className="max-w-4xl mx-auto px-5 md:px-8">
        <div className="reveal text-center mb-14">
          <p className="section-line text-gold mb-4">FAQ</p>
          <h2 className="font-display text-4xl md:text-5xl font-medium leading-tight">
            Frequently asked <span className="gold-gradient-text italic">questions.</span>
          </h2>
        </div>

        <div className="space-y-4">
          {FAQS.map(([q, a], i) => {
            const isOpen = open === i;
            return (
              <div key={q} className="reveal rounded-2xl border hairline bg-viimii-2 overflow-hidden">
                <button
                  onClick={() => setOpen(isOpen ? -1 : i)}
                  className="w-full flex items-center justify-between gap-4 px-6 py-5 text-left"
                >
                  <span className="font-display text-lg md:text-xl text-cream">{q}</span>
                  <span className="shrink-0 w-8 h-8 rounded-full grid place-items-center text-gold" style={{ background: "rgba(201,161,90,0.12)" }}>
                    {isOpen ? <Minus size={16} /> : <Plus size={16} />}
                  </span>
                </button>
                <div
                  className="grid transition-all duration-500 ease-out"
                  style={{ gridTemplateRows: isOpen ? "1fr" : "0fr" }}
                >
                  <div className="overflow-hidden">
                    <p className="px-6 pb-6 text-cream/65 leading-relaxed">{a}</p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
